import React from 'react';
import { Link } from 'react-router-dom';

function PrivacyPolicy() {
  return (
    <>
      <section class="contact-info-area pt-100 pb-70">
        <div class="container">
          <div class="row">
            <div class="col-lg-12 col-sm-12">
              <h2>Privacy Policy</h2>

              <div className="legalSection">
                <h4>Introduction</h4>
                <p>
                  This Privacy Policy explains how Pargati Online Services collects, uses, stores,
                  and protects your personal data through the Platform.
                </p>

                <h4>Information Collection</h4>
                <p>
                  We may collect personal information such as name, date of birth, address,
                  phone number, email ID, identity proof, and payment information.
                </p>

                <h4>Usage of Information</h4>
                <ul>
                  <li><i class="flaticon-check"></i>To provide and improve services</li>
                  <li><i class="flaticon-check"></i>To process transactions</li>
                  <li><i class="flaticon-check"></i>To communicate offers and updates</li>
                  <li><i class="flaticon-check"></i>To prevent fraud and enforce policies</li>
                </ul>

                <h4>Sharing of Information</h4>
                <p>
                  Personal data may be shared with affiliates, service providers, logistics partners,
                  payment partners, or law enforcement agencies when required by law.
                </p>

                <h4>Security</h4>
                <p>
                  We implement reasonable security practices; however, data transmission over
                  the internet cannot be guaranteed as completely secure.
                </p>

                <h4>Data Retention & Deletion</h4>
                <p>
                  Users may delete their account via the Platform. Data may be retained as required
                  by law or for legitimate business purposes.
                </p>

                <h4>User Rights</h4>
                <p>
                  You may access, correct, or update your personal data through the Platform.
                </p>

                <h4>Consent</h4>
                <p>
                  By using the Platform, you consent to the collection and processing of your data
                  in accordance with this Privacy Policy.
                </p>
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
}

export default PrivacyPolicy;
